import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {hashHistory} from "react-router";

import {cartItemInterface} from "../cartItemInterface";
import {canShowSqftButtonForFeature} from "../../../misc/helpers";
import {setCameFromPage} from "../../../actions/actionFunctions";
import {setSqftFromFeature} from "../../../actions/sqftFunctions";
import {setSqftOpenedFromFeature} from "../../../actions/selectionFunctions";

const CartItemCalcButton = (props) => {

  let {cartItem, setCameFromPage, fabricatorSettings, setSqftFromFeature, setClickedItemActiveQuoteIndex,
    setSqftOpenedFromFeature} = props;

  if (cartItem.isEmpty || cartItem.isMinimumCharge || !canShowSqftButtonForFeature(cartItem.cartFeature, fabricatorSettings)) {
    return null
  }

  const handleCalculatorButtonClick = async () => {
    await setClickedItemActiveQuoteIndex();
    setCameFromPage("shoppingcart");
    setSqftFromFeature(cartItem);
    setSqftOpenedFromFeature(cartItem.cartFeature);
    hashHistory.push("sqft");
  };

  return (
    <button className="aq-button aq-button--sqft" onClick={handleCalculatorButtonClick}/>
  )
};

CartItemCalcButton.propTypes = {
  cartItem: PropTypes.shape(cartItemInterface),
};

const mapStateToProps = (store) => {
  return {
    fabricatorSettings: store.fabricatorState.settings
  };
};

const mapDispatchToProps = {
  setCameFromPage,
  setSqftFromFeature,
  setSqftOpenedFromFeature,
};

export default connect(mapStateToProps, mapDispatchToProps)(CartItemCalcButton)
